import { StatementType } from "@/entities/DataAssociation/File.model";
import { ACCOUNT_LIST } from "./labeling.constants";
import { AccountCategory } from "@/entities/DataAssociation/Account.model";

export function isRowDisabled(
    isCodat: boolean,
    codatAccountId?: string | null,
) {
    return isCodat && !codatAccountId;
}

export function getCategoriesByStatementType(
    statementTypes: StatementType[],
): AccountCategory[] {
    if (statementTypes.includes(StatementType.MIXED)) {
        return Object.values(ACCOUNT_LIST).map((account) => account.category);
    }
    return Object.values(ACCOUNT_LIST)
        .filter((account) => statementTypes.includes(account.statementType))
        .map((account) => account.category);
}

export function formatFileName(name: string): string {
    const match = name.match(/raw_\d{14}_(.+)$/);
    return match ? match[1] : name;
}
